import './introduction.css';

function Introduction() {
  return (
    <main className="monitor-introduction">
      <h1>Mental Map</h1>
    </main>
  );
}

export default Introduction;
